import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDebouncedCallback } from 'use-debounce';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icons from 'components/Icons';

const useStyles = makeStyles({
  search: {
    width: '100%',
    borderRadius: '25px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '0.2rem 3rem 0 2.4rem',
    border: 0,
    outline: 'none',
    transition: '0.3s',
    fontFamily: 'Gilroy',
    '&:focus': {
      border: '1px solid grey'
    }
  },
  label: {
    position: 'relative',
    display: 'block'
  },
  progress: {
    position: 'absolute',
    top: '50%',
    right: '0.5rem',
    transform: 'translate(0, -50%)',
    display: 'flex',
    alignItems: 'center'
  },
  icon: { cursor: 'pointer' },
  searchIcon: {
    position: 'absolute',
    left: '8px',
    top: '10px'
  }
});

interface SearchTypes {
  label: string;
  onSearch?: (value: string) => void;
  background?: string;
  onClear?: Function;
  shouldClear?: boolean;
  name: string;
}

const Search = ({
  label,
  onSearch,
  background,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClear = () => {},
  shouldClear
}: SearchTypes) => {
  const classes = useStyles();
  const [value, setValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const debounced = useDebouncedCallback((value: string) => {
    if (onSearch) onSearch(value);
    setIsTyping(false);
  }, 500);

  const onChange = (e: any) => {
    setValue(e.target.value);
    setIsTyping(true);
    debounced(e.target.value);
  };

  const clearValues = () => {
    setValue('');
    if (onSearch) onSearch('');
    onClear();
  };

  const isValueProvied = value.length > 0;

  useEffect(() => {
    if (shouldClear) clearValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldClear]);

  return (
    <label className={classes.label}>
      <Icons.SearchIcon className={classes.searchIcon} />
      <input
        style={{ backgroundColor: background ? background : 'white' }}
        type="text"
        onChange={onChange}
        placeholder={label}
        value={value}
        className={classes.search}
      />
      {isTyping ? (
        <div className={classes.progress}>
          <CircularProgress size="20px" />
        </div>
      ) : (
        isValueProvied && (
          <div className={classes.progress}>
            <Icons.CloseIcon
              width="24px"
              onClick={clearValues}
              className={classes.icon}
            />
          </div>
        )
      )}
    </label>
  );
};

export default Search;
